import { useSuspenseFeatureFlagsQuery } from '#api/org.queries.ts';
import { FEATURE_UNLIMITED_FLAG } from '#util/flags.ts';
import { useSuspenseAllOIDCProvidersQuery } from '../sso-page/SSOSettingsPage.queries.ts';

/**
 * Whether the account has room for another SSO provider of any kind, mirroring the limit the API
 * enforces on provider creation. The admin slot counts: IdentityProviderFormWrapper offers one admin
 * provider per account and disables the option once one exists, so an empty slot is somewhere to put
 * a provider however many endpoint providers the account already holds.
 */
export function useSuspenseIsProvidersLimitReached() {
  const { ENDPOINT_OIDC_PROVIDERS_LIMIT } = useSuspenseFeatureFlagsQuery().data;
  const {
    data: {
      admin: { data: adminProviders },
      endpoint: { data: endpointProviders },
    },
  } = useSuspenseAllOIDCProvidersQuery();

  // This should be defined, but if the API does not yet support it, leave the limit to the server
  // rather than refusing a provider it would accept.
  if (ENDPOINT_OIDC_PROVIDERS_LIMIT === undefined) {
    return {
      isProvidersLimitReached: false,
      endpointProvidersLimit: Number.POSITIVE_INFINITY,
    };
  }

  return {
    /** Have we reached or surpassed the {@link ENDPOINT_OIDC_PROVIDERS_LIMIT}? */
    isProvidersLimitReached:
      adminProviders.length > 0 &&
      ENDPOINT_OIDC_PROVIDERS_LIMIT !== FEATURE_UNLIMITED_FLAG &&
      endpointProviders.length >= ENDPOINT_OIDC_PROVIDERS_LIMIT,
    endpointProvidersLimit: ENDPOINT_OIDC_PROVIDERS_LIMIT,
  };
}
